// libs
import { keyframes } from '@emotion/core';
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

export const slideUpAnimation = keyframes`
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0%);
    }
`;

export const Container = styled.div<{
  isBottomSheet: boolean;
  showBorder: boolean;
  saleCommunication: boolean;
  specialTag: boolean;
  gradientColors?: string[];
  specialTagGradientColor?: string[];
}>`
  background: ${({ saleCommunication, specialTag, theme, specialTagGradientColor, gradientColors }) =>
    specialTag ? `linear-gradient(80.56deg, ${specialTagGradientColor?.[0] || '#E0FAFE'} 0.51%, #FFFFFF 35.76%)` :
      saleCommunication
        ? `linear-gradient(250deg, ${gradientColors?.[0] || '#FEFEFF'} 45.51%, ${gradientColors?.[1] || '#FFEBF8'
        } 134.76%)`
        : theme.colors.surface};
  height: 66px;

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    position: sticky;
    z-index: 5;
    bottom: 0;
    left: 0;
    animation: ${slideUpAnimation} 0.3s ease-in;
    display: flex;
    justify-content: center;
    align-items: center;

    ${({ theme, isBottomSheet }) => `
      width: 100vw;
      padding: ${isBottomSheet ? `${theme.spacing.spacing80} ${theme.spacing.spacing80} 0` : `${theme.spacing.spacing40} ${theme.spacing.spacing80}`};
      margin: ${isBottomSheet ? `0 0 0 -${theme.spacing.spacing80}` : `0 0 ${theme.spacing.spacing40} -${theme.spacing.spacing80}`};
    `}

    ${({ saleCommunication, showBorder, theme, specialTag }) =>
    showBorder
      ? saleCommunication
        ? `
            border-top: 1px solid transparent;
            border-image: linear-gradient(90deg, rgba(255, 197, 234, 0.08) 0%, rgba(181, 182, 182, 0.08) 100%) 1;
            `
        : specialTag ? `
            border-top: 1px solid transparent;
            border-image: linear-gradient(90deg, rgba(200, 244, 255, 0.08) 0%, rgba(181, 182, 182, 0.08) 100%);`
          :
          `border-top: 1px solid ${theme.colors.textOutline};`
      : 'border-top: none;'}
  }
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: 0;
    width: 100%;
    animation: none;
    margin-top: ${({ theme }) => theme.spacing.spacing160};
  }
`;
